import React from 'react';
import { Container, DownTrendIcon, UpTrendIcon, Wrapper } from './TrendBox.styles';
import { THEME as theme } from '../../../../styles/theme';

interface TrendBoxProps {
  change: number | null;
  isNegative: boolean;
  hasBorder?: boolean;
}

const TrendBox: React.FC<TrendBoxProps> = ({ change, isNegative, hasBorder = false }) => {
  return (
    <Wrapper>
      <Container isNegative={isNegative} hasBorder={hasBorder}>
        {isNegative ? (
          <DownTrendIcon
            id="DownTrendIcon"
            data-testid="downTrendIcon"
            color={theme.colors.accent.red[100]}
          />
        ) : (
          <UpTrendIcon
            id="UpTrendIcon"
            data-testid="upTrendIcon"
            color={theme.colors.accent.green[100]}
          />
        )}
        {isNegative ? <div>-</div> : <div>+</div>}
        {Math.abs(change ?? 0).toFixed(1)}
      </Container>
    </Wrapper>
  );
};

export default TrendBox;
